import { render, staticRenderFns } from "./UpsertV2.vue?vue&type=template&id=facffdc6&scoped=true"
import script from "./UpsertV2.vue?vue&type=script&lang=js"
export * from "./UpsertV2.vue?vue&type=script&lang=js"
import style0 from "./UpsertV2.vue?vue&type=style&index=0&id=facffdc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "facffdc6",
  null
  
)

export default component.exports